import { roleState } from '@/store/roles';
import { accessState } from '@/store/access';

// Директива для управления видимостью элементов в зависимости от разрешений пользователя
export const vPermission = {
  mounted(el, binding) {
    const { value } = binding;
    
    if (!value) {
      console.warn('Директива v-permission требует указания разрешения или списка разрешений');
      return;
    }
    
    // Если элемент не должен отображаться, скрываем его
    if (!hasPermission(value)) {
      el.style.display = 'none';
    }
  },
  
  updated(el, binding) {
    const { value } = binding;
    
    if (!value) {
      return;
    }
    
    // Обновляем видимость при изменении разрешений
    if (hasPermission(value)) {
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  }
};

// Директива для управления доступом к элементу по роли
export const vRole = {
  mounted(el, binding) {
    const { value } = binding;
    
    if (!value) {
      console.warn('Директива v-role требует указания роли или списка ролей');
      return;
    }
    
    // Если пользователь не имеет указанной роли, скрываем элемент
    if (!hasRole(value)) {
      el.style.display = 'none';
    }
  },
  
  updated(el, binding) {
    const { value } = binding;
    
    if (!value) {
      return;
    }
    
    // Обновляем видимость при изменении роли
    if (hasRole(value)) {
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  }
};

// Функция для проверки наличия разрешения
function hasPermission(permission) {
  // Если передан массив разрешений, проверяем наличие хотя бы одного
  if (Array.isArray(permission)) {
    return permission.some(code => accessState.can(code));
  }
  
  // Если передана функция, вызываем её
  if (typeof permission === 'function') {
    return permission(roleState);
  }
  
  // Проверяем наличие конкретного разрешения
  return accessState.can(permission);
}

// Функция для проверки наличия роли
function hasRole(role) {
  // Если передан массив ролей, проверяем наличие хотя бы одной
  if (Array.isArray(role)) {
    return role.some(r => roleState.hasRole(r));
  }
  
  // Если передана функция, вызываем её
  if (typeof role === 'function') {
    return role(roleState);
  }
  
  // Проверяем наличие конкретной роли
  return roleState.hasRole(role);
}
